export default function (container, player, type) {
  const controls = container.parentNode.querySelector('[data-video-controls]');
  const muteButton = controls.querySelector('[data-video-muted]');
  const pauseButton = controls.querySelector('[data-video-paused]');

  if (muteButton) {
    muteButton.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const icon = button.querySelector('i');

      if (button.dataset.videoMuted === 'true') {
        icon.classList.remove('fa-volume-off');
        icon.classList.add('fa-volume-up');
        button.dataset.videoMuted = 'false';

        if (type === 'youtube') {
          return player.unMute();
        }

        if (type === 'vimeo') {
          return player.setVolume(1);
        }

        player.muted = false;
        return false;
      }

      icon.classList.remove('fa-volume-up');
      icon.classList.add('fa-volume-off');
      button.dataset.videoMuted = 'true';

      if (type === 'youtube') {
        return player.mute();
      }

      if (type === 'vimeo') {
        return player.setVolume(0);
      }

      player.muted = true;
      return false;
    });
  }

  if (pauseButton) {
    pauseButton.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const icon = button.querySelector('i');

      if (button.dataset.videoPaused === 'true') {
        icon.classList.remove('fa-play');
        icon.classList.add('fa-pause');
        button.dataset.videoPaused = 'false';
        container.dataset.manuallyPaused = 'false';

        if (type === 'youtube') {
          return player.playVideo();
        }

        return player.play();
      }

      icon.classList.remove('fa-pause');
      icon.classList.add('fa-play');
      button.dataset.videoPaused = 'true';
      container.dataset.manuallyPaused = 'true';

      if (type === 'youtube') {
        return player.pauseVideo();
      }

      return player.pause();
    });
  }

  controls.classList.add('BackgroundControls--init');
}
